import React from 'react';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import shapeTypes from '../../constants/ShapeConstants';
import selectionManager from '../../components/utils/SelectionManager';
import animationManager from '../utils/AnimationManager';
import createShapes from '../utils/CreateShapes';
import platformDetection from '../utils/PlatformDetection';
import configuration from '../../constants/Configuration';
import appParameters from '../utils/AppParameters';
import properties from "../../constants/Properties";
import {uiProperties} from "../utils/TransformToolUtils";
import localesManager from "../../locales/LocalesManager";

const TextBoxLabelContent = React.createClass({
    getSelectedShape () {
        const state = storeManager.getState();
        const shapes = state.currentSlide.model.content;
        var i;
        var target;

        if (!shapes)
            return target;

        for (i=0; i<shapes.length; i++)
            if (shapes[i].isSelected == true) {
                target = shapes[i];
                break;
            }

        return target;
    },
    getShapePosition(shapeModel, labelHeight) {
        const scaleProperties = this.props.scaleProperties;
        var position = {left: 0, top: 0};
        const scale = scaleProperties.scale;
        const buttonSize = properties.SHAPE_MENU_BUTTON_SIZE;
        const radius = uiProperties.RADIUS;
        var offset = 12;

        if (shapeModel.rotation > 0) {
            if (shapeModel.width > configuration.CANVAS_WIDTH && shapeModel.height > configuration.CANVAS_HEIGHT) {
                position.left = scaleProperties.topX + configuration.CANVAS_WIDTH * scale - buttonSize;
                position.top = scaleProperties.topY;
            } else
            if (shapeModel.y < 0 && (shapeModel.y + shapeModel.height) > configuration.CANVAS_HEIGHT) {
                if ((shapeModel.x + shapeModel.width + buttonSize) > configuration.CANVAS_WIDTH) // move to TopLeft
                    position.left = scaleProperties.topX + shapeModel.x * scale - buttonSize - offset;
                else
                    position.left = scaleProperties.topX + (shapeModel.x + shapeModel.width) * scaleProperties.scale + offset;
            } else {
                if (shapeModel.y < 0 && (shapeModel.x + shapeModel.width + buttonSize) > configuration.CANVAS_WIDTH) { // move to BottomLeft
                    position.left = scaleProperties.topX  + shapeModel.x * scale - buttonSize - offset;
                    position.top = scaleProperties.topY + (shapeModel.y + shapeModel.height) * scale - radius - buttonSize;

                } else if (shapeModel.y < 0) { // move to BottomRight
                    position.left = scaleProperties.topX + (shapeModel.x + shapeModel.width) * scale + offset;
                    position.top = scaleProperties.topY + (shapeModel.y + shapeModel.height) * scale - radius - buttonSize;
                } else if ((shapeModel.x + shapeModel.width + buttonSize) > configuration.CANVAS_WIDTH) { // move to TopLeft
                    position.left = scaleProperties.topX + shapeModel.x * scale - buttonSize - offset;
                    position.top = scaleProperties.topY + shapeModel.y * scale + radius;
                } else { // move to TopRight (Normal)
                    position.left = scaleProperties.topX + (shapeModel.x + shapeModel.width) * scale + offset;
                    position.top = scaleProperties.topY + shapeModel.y * scale + radius;
                }
            }

            position.top = position.top - labelHeight - 1;
        } else {
            position.left = scaleProperties.topX  + shapeModel.x * scale + 5;
            position.top = scaleProperties.topY + shapeModel.y * scale - labelHeight - 2;
        }

        if (position.left < scaleProperties.topX)
            position.left = scaleProperties.topX + offset;

        if (position.left > scaleProperties.topX + configuration.CANVAS_WIDTH * scale - labelHeight - offset)
            position.left = scaleProperties.topX + configuration.CANVAS_WIDTH * scale - labelHeight - offset;

        if (position.top < scaleProperties.topY)
            position.top = scaleProperties.topY + offset;

        if (position.top > scaleProperties.topY + configuration.CANVAS_HEIGHT * scale - labelHeight - offset)
            position.top = scaleProperties.topY + configuration.CANVAS_HEIGHT * scale - labelHeight - offset;

        return position;
    },
    render() {
        const shapeModel = this.getSelectedShape();

        if (shapeModel == undefined || platformDetection.isIOS())
            return (<div/>);

        var isTextShape = (shapeModel.type == shapeTypes.TEXTBOX || shapeModel.type == shapeTypes.TEXTBOXSIMPLE || shapeModel.type == shapeTypes.SPEAK_BUBBLE || shapeModel.type == shapeTypes.SCREAM_BUBBLE || shapeModel.type == shapeTypes.THOUGHT_BUBBLE || shapeModel.type == shapeTypes.COMPLEX_SPEAK_BUBBLE);

        if (!isTextShape || shapeModel.isInteraction == true || shapeModel.type == shapeTypes.VIDEO || selectionManager.multipleSelection() == true || animationManager.clone)
            return (<div/>);

        var shapeIndex = createShapes.getShapeIndex(shapeModel.uuid);
        var text = localesManager.getCaption('tekst', 'other');
        var ariaLabelValue = text + ' ' + shapeIndex;
        var textAreaId = 'text_area_' + shapeModel.uuid;
        const labelHeight = 20;
        const position = this.getShapePosition(shapeModel, labelHeight);

        var labelStyle = {
            position: 'absolute',
            background: '#055685',
            borderRadius: 10,
            color: 'white',
            fontSize: 12,
            top: position.top,
            left: position.left,
            paddingLeft: 7,
            paddingRight: 7,
            paddingTop: 2,
            paddingBottom: 2,
            display: 'block'
        };

        return (
            <label id='textBoxLabel' aria-label={ariaLabelValue} htmlFor={textAreaId} style={labelStyle}>{ariaLabelValue}</label>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const slideModel = state.currentSlide.model;

    return {
        slideModel
    };
}

export const TextBoxLabel = connect(mapStateToProps)(TextBoxLabelContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/TextBoxLabel.js
 **/